import type { LocalCartItem, Ticket } from 'restful/tickets';
import { TicketStatusFragment } from 'types/api/dato-operations.types';

import AmountSelector from 'components/@tickets/AmountSelector';

import TicketItemRow from './TicketItemRow';

interface Props {
  ticket: Ticket;
  status?: TicketStatusFragment;
  cartItem: LocalCartItem | undefined;
  onAddItem: (ticket: Ticket) => void;
  onRemoveItem: (ticket: Ticket) => void;
  onOpenDetail: (ticket: Ticket) => void;
}

const TicketItem = ({
  ticket,
  status,
  cartItem,
  onAddItem,
  onRemoveItem,
  onOpenDetail,
}: Props) => {
  const quantity = cartItem?.quantity ?? 0;

  const handleAdd = () => onAddItem(ticket);
  const handleRemove = () => onRemoveItem(ticket);

  return (
    <TicketItemRow ticket={ticket} status={status} onOpenDetail={onOpenDetail}>
      <AmountSelector
        quantity={quantity}
        isRemoveDisabled={quantity <= 0}
        onRemove={handleRemove}
        onAdd={handleAdd}
      />
    </TicketItemRow>
  );
};

export default TicketItem;
